import React, { memo } from "react";
import CompletionTrendChart from "./CompletionTrendChart";
import OverdueTrendChart from "./OverdueTrendChart";

const DashboardTrendCharts = ({ completionPoints = [], overdueRows = [] }) => (
  <div className="dashboard-trend-charts">
    <CompletionTrendChart points={completionPoints} />
    <OverdueTrendChart rows={overdueRows} />
  </div>
);

export default memo(DashboardTrendCharts);
